<div class="sorting-container" *ngIf="showControls">
  <div class="sorting-left">
    <span class="sort-label">Sort By</span>
    <app-custom-dropdown
      [options]="sortByOptions"
      [(ngModel)]="sortBy"
      [height]="'20px'"
      (selectionChange)="onSortByChange()">
    </app-custom-dropdown>
    <app-custom-dropdown
      [options]="sortOrderOptions"
      [(ngModel)]="sortOrder"
      [height]="'20px'"
      (selectionChange)="onSortOrderChange()">
    </app-custom-dropdown>
    <span class="sort-label">Group By</span>
    <app-custom-dropdown
      [options]="groupByOptions"
      [(ngModel)]="groupBy"
      [height]="'20px'"
      (selectionChange)="onGroupByChange()">
    </app-custom-dropdown>
  </div>
  <button class="other-filters-btn" #otherFiltersBtn (click)="onOpenFilters($event)">Other Filters({{ activeFiltersCount }})</button>
</div>
<div class="select-all-container" *ngIf="hasOrders && !hideCheckboxes">
  <mat-checkbox
    [checked]="selectAllChecked"
    [indeterminate]="selectAllIndeterminate"
    (change)="selectAllChange.emit($event.checked)">
    Select All
  </mat-checkbox>
</div>

